import { Injectable, inject } from '@angular/core';
import { Leistungseinheit } from '../../../domain/model/leistungseinheit';
import { StorageService } from '../storage/storage.service';

@Injectable({
    providedIn: 'root',
})
export class PreferencesService {
    private storageService = inject(StorageService);

    public getPreferredErzeugungsanlagenView(fallback?: string): string {
        const val = this.storageService.getPreferredErzeugungsanlagenView();
        if (val === null && fallback !== null) {
            return fallback;
        } else {
            return val;
        }
    }

    public setPreferredErzeugungsanlagenView(view: string) {
        this.storageService.setPreferredErzeugungsanlagenView(view);
    }

    public getPreferredLeistungseinheitView(fallback?: Leistungseinheit): Leistungseinheit {
        const val = this.storageService.getPreferredLeistungseinheitView();
        if (val === null && fallback !== null) {
            return fallback;
        } else {
            return val as Leistungseinheit;
        }
    }

    public setPreferredLeistungseinheitView(view: Leistungseinheit) {
        this.storageService.setPreferredLeistungseinheitView(view);
    }

}
